import React, { Component } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import ErrorMessage from '../../../../ErrorMessage';
import LoadingIcon from '../../../../LoadingIcon';
import UserService from '../../../../../Services/userService';
import stringHelper from '../../../../../Helpers/stringHelper';

export default class UserMultiChoice extends Component {
  static defaultProps = {
    label: '',
    fieldName: '',
    onChange: () => alert('UserMultiChoice OnChange'),
    selected: [],
    active: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      itemList: [],
      selected: [],
    };
    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selected !== this.props.selected) {
      this.populateListData();
    }
  }

  populateListData() {
    UserService.GetUserList()
      .then((result) => {
        result.sort((a, b) =>
          `${a.lastname} ${a.firstName}`.toLocaleLowerCase() > `${b.lastname} ${b.firstName}`.toLocaleLowerCase()
            ? 1
            : -1
        );
        const optValues = [];
        const selected = [];
        result.forEach((user) => {
          if (!this.props.active || user.isActive) {
            optValues.push({
              label: `${user.firstName} ${user.lastName}${stringHelper.toBracket(user.userName)}`,
              value: user.userId,
              disabled: false,
            });
          }

          if (
            this.props.selected &&
            (this.props.selected.includes(user.userId) || this.props.selected.includes(user.userId.toString()))
          ) {
            selected.push({
              label: `${user.firstName} ${user.lastName}${stringHelper.toBracket(user.userName)}`,
              value: user.userId,
              disabled: false,
            });
          }
        });
        this.setState({ itemList: optValues, loading: false, selected });
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('UMC59');
        this.setState({ itemList: [], loading: false });
      });
  }

  multiSelectOnChange(selected) {
    this.setState({ selected: selected });
    this.props.onChange(
      this.props.fieldName,
      selected.map((i) => i.value)
    );
  }

  renderList() {
    return (
      <MultiSelect
        className='rmsc'
        options={this.state.itemList}
        value={this.state.selected}
        onChange={this.multiSelectOnChange}
        labelledBy='Select'
      />
    );
  }

  render() {
    return (
      <div className='w-100'>
        <div className='text-center hover rounded arial'>
          {this.props.label && (
            <label
              className='m-0 p-0 defaultfontsize '
              htmlFor={'htmlidfor' + this.props.fieldName}
            >
              {this.props.label}
            </label>
          )}
          {this.state.loading ? (
            <LoadingIcon
              loading={true}
              className='h6'
            />
          ) : (
            this.renderList()
          )}
        </div>
      </div>
    );
  }
}
